"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var convertAnyJson = function (any, convert) {
    switch (typeof any) {
        case 'object':
            if (any === null)
                return null;
            if (any instanceof Array)
                return any.map(function (item) { return convertAnyJson(item, convert); });
            if (any instanceof Date)
                return any;
            return convertJsonMap(any, convert);
        default:
            return any;
    }
};
var convertJsonMap = function (param, convert) {
    return Object.entries(param).reduce(function (acc, _a) {
        var key = _a[0], value = _a[1];
        ;
        acc[convert(key)] = convertAnyJson(value, convert);
        return acc;
    }, {});
};
var convert = function (param, convert) {
    switch (typeof param) {
        case 'string':
            return convert(param);
        default:
            return convertJsonMap(param, convert);
    }
};
exports.default = convert;
//# sourceMappingURL=convert.js.map